import z from "zod";

export enum AverageWaitTime {
  UNDER_10_MIN = "<10 min",
  TEN_TO_20_MIN = "10-20 min",
  TWENTY_TO_30_MIN = "20-30 min",
  OVER_30_MIN = ">30 min",
}

export const averageTimeList = Object.values(AverageWaitTime);

export const BranchReservationSchema = z
  .object({
    reservationMethods: z.array(z.string()),
    averageWaitTime: z.string().min(1, "Please select average wait time"),
    reservationRequired: z.boolean().optional(),

    tags: z.array(z.string()).min(1, "Please select at least one tag"),

    ambiance: z
      .array(z.string())
      .min(1, "Please select at least one ambiance option"),

    dressCode: z
      .array(z.string())
      .min(1, "Please select at least one dress code"),

    moment: z.array(z.string()).min(1, "Please select at least one moment"),

    priceLevel: z
      .array(z.number())
      .min(1, "Please select at least one type of price"),
  })
  .superRefine((data, ctx) => {
    if (
      data.reservationRequired &&
      (!data.reservationMethods || data.reservationMethods.length === 0)
    ) {
      ctx.addIssue({
        path: ["reservationMethods"],
        code: z.ZodIssueCode.custom,
        message: "Please select at least one reservation method",
      });
    }
  });

export type BranchReservationType = z.infer<typeof BranchReservationSchema>;
